import React, { useCallback, useEffect, useState } from 'react'

const CheckboxFilter = ({handleParams, params, paramKey, label}) => {

	const checkIsSet = useCallback(()=>{
		return params.get(paramKey)
	},[params, paramKey])

	const [state, setState] = useState(checkIsSet());

	useEffect(()=>{
		const key = params.get(paramKey)
		
		if ( state !== key) {
			const newParams = new URLSearchParams(params.toString());
			newParams.set(paramKey, state ? 'true' : null)

			if(state === null){
				newParams.delete(paramKey)
			}

			handleParams(newParams)
		}
	},[state])

	useEffect(()=>{
		const key = params.get(paramKey);
		if( key !== state ) {
			setState(key)
		}
	},[params])

	return (
		<div className={`checkbox-wrapper${state ? ' active':''}`}>
			<input defaultChecked={ state !== null } id={paramKey} value='true' type="checkbox" name={paramKey} />
			<label 
				htmlFor={paramKey}
				onClick={()=>{
					setState( state ? null : 'true' )
				}}
				>{label}</label>
		</div>
	)
}

export default CheckboxFilter